import React from "react";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 grid sm:grid-cols-3 gap-8 text-sm text-white/50">
        <div>
          <div className="font-display font-bold text-white mb-2">INFINITY</div>
          <p>Every accessory of your mobile is important to showcase your value.</p>
        </div>
        <div>
          <div className="font-semibold text-white mb-2">Support</div>
          <p>Shipping & returns</p>
          <p>Warranty</p>
          <p>Contact us</p>
        </div>
        <div>
          <div className="font-semibold text-white mb-2">Company</div>
          <p>About</p>
          <p>Careers</p>
          <p>Privacy policy</p>
        </div>
      </div>
      <div className="text-center text-white/30 text-xs font-mono pb-6">
        © {new Date().getFullYear()} Infinity Mobile Accessories. All rights reserved.
      </div>
    </footer>
  );
}
